module.exports = __webpack_public_path__ + "static/media/iyzico-setup-step1.a0d5a8ac.png";